import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { ErrorHandlerService } from './error-handler/error-handler.service';
import { FooterComponent } from './footer/footer.component';
import { CUSTOM_INTERCEPTORS } from './interceptors';
import { LoadingComponent } from './loading/loading.component';
import { NavbarComponent } from './navbar/navbar.component';
import localeEs from '@angular/common/locales/es-CL';
import { registerLocaleData } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BrowserModule } from '@angular/platform-browser';
import { NgxBarcode6Module } from 'ngx-barcode6';
// import { DashboardComponent } from '../dashboard/dashboard.component';
import { CustomSelectModule } from './custom-select/custom-select.module';
import { HomePgsComponent } from './home-pgs/home-pgs.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PgsSelectSearchModule } from '../cdk/pgs-select-search/pgs-select-search.module';
import { SecurityModule } from '@app/core/security/security.module';

registerLocaleData(localeEs, 'es');


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SecurityModule,
    NgxDatatableModule,
    NgbModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 3000
    }),
    NgxWebstorageModule.forRoot({prefix: 'pgs', caseSensitive: true, separator: '_'}),
    PgsSelectSearchModule,
    BrowserModule,
    NgxBarcode6Module,
    CustomSelectModule
    // HttpClientInMemoryWebApiModule.forRoot(MockData, { passThruUnknownUrl: true })
  ],
  exports: [
    NavbarComponent,
    LoadingComponent,
    ConfirmComponent,
    FooterComponent,
    BreadcrumbsComponent,
    HomePgsComponent,
    // DashboardComponent
  ],
  declarations: [
    NavbarComponent,
    LoadingComponent,
    ConfirmComponent,
    FooterComponent,
    BreadcrumbsComponent,
    HomePgsComponent,
    // DashboardComponent
  ],
  providers: [
    CUSTOM_INTERCEPTORS,
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    }
  ]
})
export class CoreModule { }
